import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

export interface DropdownMenuItem {
  value: any;
  label: string;
  icon?: string;
}

@Component({
  selector: 'tidy-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownMenuComponent {
  @Input() triggerText = '';
  @Input() triggerIcon = 'expand_more';
  @Input() items: DropdownMenuItem[] = [];
  @Input() selectedValue: any = null;
  @Input() showCheckmarks = true;
  @Input() placeholder = 'Select...';
  @Output() selectItem$ = new EventEmitter<any>();

  isOpen = false;

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  close(): void {
    this.isOpen = false;
  }

  onSelectItem(item: DropdownMenuItem): void {
    this.selectItem$.emit(item.value);
    this.close();
  }

  get displayText(): string {
    if (this.triggerText) {
      return this.triggerText;
    }
    const selected = this.items.find(item => item.value === this.selectedValue);
    return selected ? selected.label : this.placeholder;
  }
}
